import axiosInstance, { microServices } from 'network/apis'
import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants'

const LIST = (competitionId) => `/v1/competitions/${competitionId}/stages`
const GET_ONE = (competitionId, stageId) => `/v1/competitions/${competitionId}/stages/${stageId}`
const CREATE = (competitionId) => `/v1/competitions/${competitionId}/stages`
const UPDATE = (competitionId, stageId) => `/v1/competitions/${competitionId}/stages/${stageId}`
const DELETE = (competitionId, stageId) => `/v1/competitions/${competitionId}/stages/${stageId}`


export const listStagesService = (payload) => {
  const { competitionId, data } = payload
  return axiosInstance(
    METHOD_TYPES.get,
    LIST(competitionId),
    data,
    {
      server: microServices.BASE_URL1,
      handlerEnabled: true,
      loader: LOADER_HANDLER_TYPES.page,
    }
  )
}

export const getStageService = (payload) => {
  const { competitionId, stageId } = payload

  return axiosInstance(
    METHOD_TYPES.get,
    GET_ONE(competitionId, stageId),
    {},
    {
      server: microServices.BASE_URL1,
      handlerEnabled: true,
      loader: LOADER_HANDLER_TYPES.submit,
    }
  )
}

export const createStageService = (payload) => {
  const { competitionId, data } = payload

  return axiosInstance(
    METHOD_TYPES.post,
    CREATE(competitionId),
    data,
    {
      server: microServices.BASE_URL1,
      handlerEnabled: true,
      loader: LOADER_HANDLER_TYPES.page,
      successMessage: 'تم الإضافة بنجاح'
    }
  )
}

export const updateStageService = (payload) => {
  const { competitionId, stageId, data } = payload

  return axiosInstance(
    METHOD_TYPES.put,
    UPDATE(competitionId, stageId),
    { ...data },
    {
      server: microServices.BASE_URL1,
      handlerEnabled: true,
      loader: LOADER_HANDLER_TYPES.page,
      successMessage: 'تم التعديل بنجاح'
    }
  )
}
export const deleteStageService = (payload) => {
  const { competitionId, stageId } = payload

  return axiosInstance(
    METHOD_TYPES.delete,
    DELETE(competitionId, stageId),
    {},
    {
      server: microServices.BASE_URL1,
      handlerEnabled: true,
      loader: LOADER_HANDLER_TYPES.page,
      successMessage: 'تم الحذف بنجاح'
    }
  )
}
